<template>
    <div class="container">
        <div class="w-100 d-flex justify-content-start">
            <ul class="nav nav-tabs w-100 nav-fill">
                <li class="nav-item" :class="{ statestabshadow: statsSection == 'synthetic' }"
                    @click.prevent="endleStatSectionChange('synthetic')">
                    <a class="nav-link" :class="{ active: statsSection == 'synthetic' }" style="font-size: 1.8rem;"
                        href="#">Données synthétiques</a>
                </li>
            </ul>
        </div>
        <div>
            <PpomStats v-if="statsSection == 'synthetic'" :section="section" :tag='tag' :dfperims='dfperims'
                :terrLevelSelected='terrLevelSelected' :terrCodeSelected='terrCodeSelected'
                :terrLabelSelected='terrLabelSelected' :millesime='millesime' />
        </div>
    </div>

</template>

<script>
import PpomStats from './PpomStats.vue';
import Loading from '../Loading.vue';
import PpomService from '../../services/PpomService';
import CogApiService from '../../services/CogApiService';

//const coproffService = new CoproffService();
const cogApiService = new CogApiService();

export default {
    name: "ppom_stats_home",
    props: ['tag', 'dfperims', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected', 'millesime', 'section'],
    components: {
        PpomStats,
        Loading
    },
    data: function () {
        return {
            loading: false,
            statsSection: 'synthetic',
            terrRef: [
                {
                    "code": '11',
                    "label": 'France',
                    "level": 'fra'
                }
            ],
            data: [],
            data2: [],
            stats: [],
            stats2: [],
            listTerrs: [],
            selectedCodeTerr: '',
            terrLevelRef: '',
            terrNameRef: '',
            millesimeRef: '',
            refsReference: [],
            refsVal: null,
            refsVal2: null,
            ppomService: null,
            userPerims: null,
            terrLabelTitleSelected: null,
            ept_coms: null,
            multiCodes: null,
            terrLevel: null,
            terrCode: null,
            terrLabel: null,
            purData: null
        }
    },
    mounted() {
        this.ppomService = new PpomService();
        this.millesimeRef = JSON.parse(this.millesime);

        this.userPerims = JSON.parse(this.dfperims);
        this.terrLabel = this.terrLabelSelected;
        this.terrCode = this.terrCodeSelected;
        this.terrLevel = this.terrLevelSelected;
        console.log("dfperims : ", this.userPerims, this.terrLevelSelected, this.terrCodeSelected, this.terrLabelSelected);
        if (this.userPerims.df_ano && this.userPerims.df_ano.dep.length > 0) {
            this.buildDFPerims(this.userPerims.df_ano);
        }

        if (localStorage.currentsection !== 'ppom' && this.section === 'ppom') {
            $("#convModal").modal('show');
            localStorage.currentsection = 'ppom';
        }
        this.ppomService.getRefs("synthetic").then(result => {
            this.refsReference = Array.from(JSON.parse(JSON.stringify(result)));
            this.refsVal = Array.from(JSON.parse(JSON.stringify(result)));
            this.refsVal2 = Array.from(JSON.parse(JSON.stringify(result)));
            this.buildUserLevel();
        })
    },
    watch: {},
    methods: {
        persist() {
            localStorage.currentsection = this.section;
        },
        endleStatSectionChange: function (section) {
            this.statsSection = section;
        },
        buildDFPerims: function (refPerims) {

            if (this.terrLevelSelected === "ept" && refPerims.comm && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                this.terrLevelSelected = "ept";
                //this.terrCodeSelected = refPerims.comm[0];
                this.terrLabelTitleSelected = "EPT ";
                this.ept_coms = refPerims.comm;
                return { "level": 'ept', "code": this.terrCodeSelected, "label": "EPCI" };
            }

            if (this.terrLevelSelected === "epci" && refPerims.comm && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                this.terrLevelSelected = "epci";
                this.terrLabelTitleSelected = "EPCI ";
                return { "level": 'epci', "code": this.terrCodeSelected, "label": "EPCI" };
            }


            if ("fr_entiere" in refPerims && refPerims.fr_entiere) {
                this.terrLevelSelected = "fra";
                this.terrCodeSelected = "fra";
                this.terrLabelTitleSelected = "";
                return { "level": 'fra', "code": 'fra', "label": "France entière" };
            }
            if ("reg" in refPerims && Array.isArray(refPerims.reg) && refPerims.reg.length > 0) {
                this.terrLevelSelected = "reg";
                this.terrCodeSelected = refPerims.regt[0];
                this.terrLabelTitleSelected = "Région ";
                return { "level": 'reg', "code": refPerims.reg[0], "label": "Régions" };
            } else if ("dep" in refPerims && Array.isArray(refPerims.dep) && refPerims.dep.length > 0) {

                if (refPerims.dep.length > 1) {
                    this.terrLevelSelected = "multi_dep";
                    this.terrLabelTitleSelected = "Multi départemental "
                    this.multiCodes = refPerims.dep;
                    this.terrCodeSelected = refPerims.dep[1];
                } else {
                    this.terrLevelSelected = "dep";
                    this.terrLabelTitleSelected = "Département ";
                    this.terrCodeSelected = refPerims.dep[0];
                }

                return { "level": 'dep', "code": refPerims.dep[0], "label": "Département" };

            } else if ("comm" in refPerims && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                let coms = refPerims.comm;
                return {
                    "level": coms.length > 1 ? 'epci' : 'com',
                    "code": coms.length > 1 ? coms[1] : [],
                    "label": coms.length > 1 ? "Communes " : "Commune"
                };
            } else {
                return null;
            }
        },

        buildUserLevel: function () {
            switch (this.terrLevelSelected) {
                case 'fra':
                    axios.get("https://geo.api.gouv.fr/regions?fields=nom,code")
                        .then((result) => {
                            this.listTerrs = result.data;
                        })
                    this.getData('11', 'reg', 2);
                    this.selectedCodeTerr = '11';
                    this.terrLevelRef = "reg";
                    this.terrNameRef = "Région";
                    this.terrLabelSelected = "France entière";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'reg':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/regions/${this.terrCodeSelected}/departements?fields=nom,code,region`)
                        .then((result) => {
                            console.log("reg result", result.data);
                            this.terrLabelSelected = result.data[0].region.nom;// nom de la région 
                            this.listTerrs = result.data;
                            this.selectedCodeTerr = result.data[0].code;
                            this.getData(result.data[0].code, 'dep', 2);
                        })

                    this.terrLevelRef = "dep";
                    this.terrNameRef = "Département";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'dep':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/departements/${this.terrCodeSelected}?fields=codeRegion,region`)
                        .then((result) => {
                            console.log("api result : ", result.data);
                            this.listTerrs = [
                                {
                                    "code": result.data.region.code,
                                    "nom": result.data.region.nom
                                }
                            ];
                            this.selectedCodeTerr = result.data.region.code;
                            this.terrLabelSelected = result.data.nom;
                            this.getData(result.data.region.code, 'reg', 2);
                        })
                    this.terrLevelRef = "reg";
                    this.terrNameRef = "Région";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'multi_dep':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    this.userPerims.df_ano.dep.forEach(element => {
                        axios.get(`https://geo.api.gouv.fr/departements/${element}?fields=nom,code`)
                            .then((result) => {
                                this.listTerrs = [
                                    ...this.listTerrs,
                                    {
                                        "code": result.data.code,
                                        "nom": result.data.nom
                                    }
                                ]
                            })
                            .finally(() => {
                                if (this.listTerrs.length === this.userPerims.dep_complet.length) {
                                    this.listTerrs = this.listTerrs.sort((a, b) => a.code > b.code ? 1 : -1);
                                    this.selectedCodeTerr = this.listTerrs[0].code;
                                    this.getData(this.selectedCodeTerr, 'dep', 2);
                                }
                            })
                    });
                    this.terrLevelRef = "dep";
                    this.terrNameRef = "Département";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'epci':
                    axios.get(`https://geo.api.gouv.fr/epcis/${this.terrCodeSelected}/communes?fields=code,nom`)
                        .then((result) => {
                            console.log("epci", result.data);
                            this.listTerrs = result.data;
                            this.selectedCodeTerr = this.listTerrs[1].code;
                            this.terrLabelSelected = this.listTerrs[0].nom;
                            this.terrCodeSelected = this.listTerrs[0].code;
                            this.getData(this.selectedCodeTerr, 'com', 2);
                        })
                    this.terrLevelRef = "com";
                    this.terrNameRef = "Communes";
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                case 'ept':
                    this.listTerrs = [];
                    if (this.ept_coms && this.ept_coms.length > 0) {

                        this.ept_coms.forEach((com, index) => {
                            axios.get(`https://geo.api.gouv.fr/communes/${com}?fields=code,nom`)
                                .then((result) => {
                                    this.listTerrs = [...this.listTerrs,
                                    {
                                        "code": result.data.code,
                                        "nom": result.data.nom
                                    }
                                    ];

                                    if (index === this.ept_coms.length - 1) {
                                        //console.log("listTerrs", this.listTerrs);
                                        this.selectedCodeTerr = this.listTerrs[0].code;
                                        this.getData(this.selectedCodeTerr, 'com', 2);
                                    }
                                })

                        })
                        this.terrLevelRef = "com";
                        this.terrNameRef = "Communes";
                        this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    }
                    break;
                case 'com':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 4) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/communes/${this.terrCodeSelected}?fields=departement`)
                        .then((result) => {
                            console.log("result com : ", result.data);
                            this.listTerrs = [
                                {
                                    "code": result.data.departement.code,
                                    "nom": result.data.departement.nom
                                }
                            ];
                            this.selectedCodeTerr = result.data.departement.code;
                            this.terrLabelSelected = result.data.nom;
                            this.getData(result.data.departement.code, 'dep', 2);
                        })
                    this.terrLevelRef = "dep";
                    this.terrNameRef = "Département"
                    this.getData(this.terrCodeSelected, this.terrLevelSelected, 1);
                    break;
                default:
                    break;
            }
        },
        getData: function (inseeCode, terrLevel, order = 1) {
            order === 1 ? this.loading = true : null;
            order === 2 ? this.loading2 = true : null;
            let that = this;
            axios.post('/api/ppom/stats', { "code": inseeCode, "level": terrLevel, "thema": "synthetic" }).then((result) => {
                // L'API retourne un tableau avec un seul élément, on prend le premier
                const dataValue = Array.isArray(result.data) ? result.data[0] : result.data;
                if (order === 1) {
                    this.purData = dataValue;
                    this.stats = that.ppomService.mergeData(dataValue, that.refsVal, order);
                } else {
                    this.stats2 = that.ppomService.mergeData(dataValue, that.refsVal2, order);
                }
            }).catch((error) => {
                console.log('PpomStatsHome getData error', error);
            }).finally(() => {
                order === 1 ? this.loading = false : null;
                order === 2 ? this.loading2 = false : null;
            });
        },
        dowloadDataAsCSVFile: function () {

            let text = "";
            for (const [key, value] of Object.entries(this.purData)) {
                text += `${key};${value}\n`;
            }
            let filename = 'ppom_tabl_cadrage_' + this.terrCodeSelected + '.csv';
            let element = document.createElement('a');
            element.setAttribute('href', 'data:application/csv;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        handleRefChange: function () {
            this.stats2 = Array.from(JSON.parse(JSON.stringify(this.refsReference)));
            this.getData(this.selectedCodeTerr, this.terrLevelRef, 2);
        }
    }
};
</script>

<style scoped>
.coproff-csv-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border-radius: 3px;
    transition: background-color 0.15s ease-in-out;
}

.statestabshadow {
    box-shadow: black 1px -3px 6px -6px;
}
</style>